module.exports = __webpack_public_path__ + "static/media/02_Entrepreneur.2edfc389.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/press/02_Entrepreneur.png
// module id = 540
// module chunks = 0